import React from "react";
import { SideIllustration } from "../components/common/SideIllustration";
import { IMAGE_SOURCES } from "../mock/imageSources";

export default function CertificationRecognition() {
  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Certification &amp; Global Recognition</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Certification issued by Global Music Conservatory confirms the level of musical achievement demonstrated in an examination. Certificates are designed to be clear and informative for candidates, families and institutions.
        </p>
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Certification process</h2>
          <p>
            Following the completion of marking and quality assurance checks, candidates receive an official result and, where the minimum requirements are met, a certificate. Certificates indicate the instrument, level, examination mode and grade awarded.
          </p>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.certificationPiano}
          alt="Student receiving formal recognition for music examination"
        />
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-slate-50/80 p-5 shadow-sm backdrop-blur-xl md:grid-cols-[minmax(0,3fr)_minmax(0,2fr)] md:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Global recognition</h2>
          <p>
            The structured, level-based nature of the certification system enables teachers, institutions and other boards to interpret results in a consistent manner. This supports decisions related to placement, ensemble participation and progression to further study.
          </p>
        </div>
        <SideIllustration
          src={IMAGE_SOURCES.certificationSheet}
          alt="Formal sheet music representing recognised achievement"
        />
      </section>
    </div>
  );
}
